import { YardReportOrderByField } from '@/core/domain/visual-management/yard-report/yard-report.enums';
import { Form, Radio, Typography } from 'antd';

export default function YardManagementReportOrderBy() {
  const options = [
    { value: YardReportOrderByField.Plate, label: 'Placa' },
    { value: YardReportOrderByField.EntryDate, label: 'Data de entrada' },
    {
      value: YardReportOrderByField.EstimateLeaveDate,
      label: 'Data de entrega',
    },
    { value: YardReportOrderByField.Customer, label: 'Clientes' },
  ];

  return (
    <>
      <Typography.Title level={5}>Ordenar por</Typography.Title>

      <Form.Item
        name="orderByField"
        initialValue={YardReportOrderByField.Plate}
        noStyle
      >
        <Radio.Group optionType="button" buttonStyle="solid" size="large">
          {options.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </>
  );
}
